import React, { Component } from 'react';
import { Table, Modal } from 'antd';
// import axios from 'axios';

class OrderSheetModal extends Component {
    state = {
        loading: false,
        // generateData: [],
    }

    // componentDidMount = () => {
    // const { refillId } = this.props;

    // console.log(this.props.refillId, 'here is the value');

    // axios({
    //     method: 'get',
    //     url: `/order_sheet.json?refill_number=${refillId}`,
    //     headers: { Authorization: sessionStorage.getItem('jwtToken') },
    // })
    //     .then((response) => {
    //         this.setState({
    //             generateData: response.data,
    //         });
    //     });
    // }


    render() {
        const { visible, onCancel, generateData } = this.props;
        // console.log(generateData);
        // const { generateData } = this.state;
        // console.log(this.state.generatedData);
        // console.log(refillId);

        const length = generateData.length > 0 ? Object.keys(generateData[0]).length : 0;
        let column1 = [];
        let column2 = [];
        let column3 = [];

        if (length <= 4) {
            column1 = [];

            for (let i = 0; i < length; i++) {
                const val = {
                    title: `Dose ${i + 1}`,
                    key: `key${i + 1}`,
                    dataIndex: `key${i + 1}`,
                    // className: 'indColumn',
                    // style: { fontSize: '30px' },

                    align: 'center',
                };
                // console.log('yes');
                column1.push(val);
                // console.log(column1);
            }
        } else if (length >= 5 && length <= 8) {
            column1 = [];
            column2 = [];
            console.log(10);

            for (let i = 0; i < 4; i++) {
                const val = {
                    title: `Dose ${i + 1}`,
                    key: `key${i + 1}`,
                    dataIndex: `key${i + 1}`,
                    align: 'center',
                    // className: 'indColumn',
                };
                // console.log('yes');
                column1.push(val);
            }

            for (let i = 4; i < length; i++) {
                const val = {
                    title: `Dose ${i + 1}`,
                    key: `key${i + 1}`,
                    dataIndex: `key${i + 1}`,
                    align: 'center',
                    // className: 'indColumn',
                };
                // console.log('yes');
                column2.push(val);
                // console.log(column1);
                // console.log(column2);
            }
        } else if (length >= 9 && length <= 12) {
            column1 = [];
            column2 = [];
            column3 = [];
            console.log(15);

            for (let i = 0; i < 4; i++) {
                const val = {
                    title: `Dose ${i + 1}`,
                    key: `key${i + 1}`,
                    dataIndex: `key${i + 1}`,
                    align: 'center',
                    // className: 'indColumn',
                };
                // console.log('yes');
                column1.push(val);
            }

            for (let i = 4; i < 8; i++) {
                const val = {
                    title: `Dose ${i + 1}`,
                    key: `key${i + 1}`,
                    dataIndex: `key${i + 1}`,
                    align: 'center',
                    // className: 'indColumn',
                };
                // console.log('yes');
                column2.push(val);
            }

            for (let i = 8; i < length; i++) {
                const val = {
                    title: `Dose ${i + 1}`,
                    key: `key${i + 1}`,
                    dataIndex: `key${i + 1}`,
                    align: 'center',
                    // className: 'indColumn',
                };
                // console.log('yes');
                column3.push(val);
            }
        }

        return (
            <Modal
                visible={visible}
                title="Order Sheet"
                style={{ textAlign: 'center', top: 20 }}
                width="75%"
                onCancel={onCancel}
                footer={null}
            >
                <h6 style={{ textAlign: 'center' }}>Dose information</h6>

                <Table
                    pagination={false}
                    dataSource={generateData}
                    className="printHead"
                    rowClassName="printColumn"
                    columns={column1}
                    bordered
                    size="small"
                    style={{ whiteSpace: 'pre' }}
                />

                <br />

                <Table
                    pagination={false}
                    dataSource={generateData}
                    className="printHead"
                    rowClassName="printColumn"
                    size="small"
                    columns={column2}
                    bordered
                    style={{ whiteSpace: 'pre' }}
                />

                <br />

                <Table
                    pagination={false}
                    dataSource={generateData}
                    className="printHead"
                    rowClassName="printColumn"
                    size="small"
                    columns={column3}
                    bordered
                    style={{ whiteSpace: 'pre' }}
                />
            </Modal>
        );
    }
}

export default OrderSheetModal;



// WEBPACK FOOTER //
// ./src/component/FetchOrderList/OrderSheetModal.js